import { cn } from '@/lib/cn';
import { inicialesDe } from '@/lib/negocio';

/** El sello del negocio: sus iniciales en un cuadro de esquinas redondas. */
export function Sello({ nombre, grande = false }: { nombre: string; grande?: boolean }) {
  return (
    <span
      aria-hidden
      className={cn(
        // 21-oct, macOS 27: el sello va en el acento (el fucsia de Trendísima, #DB2777: letra blanca 4,6:1).
        'grid shrink-0 place-items-center bg-acento font-bold tracking-wide text-white',
        grande ? 'h-14 w-14 rounded-2xl text-lg' : 'h-7 w-7 rounded-[7px] text-xs',
      )}
    >
      {inicialesDe(nombre)}
    </span>
  );
}
